import { render, staticRenderFns } from "./control3Wordshockjc.vue?vue&type=template&id=f33f262c&scoped=true&"
import script from "./control3Wordshockjc.vue?vue&type=script&lang=js&"
export * from "./control3Wordshockjc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f262c",
  null
  
)

export default component.exports